export default __webpack_public_path__ + "static/media/georgia.7ff1116b.jpg";